import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ManageContractComponent } from './manage-contract/manage-contract.component';
import { DashboardComponent } from 'src/app/core/layouts/dashboard/dashboard.component';
import { AdministrativeDashboardComponent } from './dashboard/dashboard.component';
import { ManageCompanyComponent } from './manage-company/manage-company.component';
import { AppraisalListComponent } from './manage-appraisal/appraisal-list/appraisal-list.component';
import { ManageModuleComponent } from './manage-module/manage-module.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    children: [
      {
        path: 'manage-contract',
        component: ManageContractComponent,
      },
      { path: '', component: AdministrativeDashboardComponent },
      { path: 'manage-contract', component: ManageContractComponent },
      { path: 'manage-company', component: ManageCompanyComponent },
      { path: 'manage-appraisal', component: AppraisalListComponent },
      { path: 'manage-module', component: ManageModuleComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdministrativeRoutingModule { }
